import flatten from "./flatten";

export function searchList(text, list) {
  return list.filter(function (item) {
    const str = toStr(flatten([item])[0]);
    return (
      str
        ?.toLowerCase()
        .replace(/[^a-z0-9]/g, "")
        ?.search(text?.toLowerCase()?.replace(/[^a-z0-9]/g, "")) !== -1
    );
  });
}

function toStr(each) {
  let str = "";
  for (var i in each) {
    str += each[i] + " ";
  }
  return str;
}
